/* @flow */
export const WeekEnum = Object.freeze({
    WEEK1: 'WEEK1',
    WEEK2: 'WEEK2',
    WEEK3: 'WEEK3',
    WEEK4: 'WEEK4'
});

export const WeekShortEnum = Object.freeze({
    W1: 'WEEK1',
    W2: 'WEEK2',
    W3: 'WEEK3',
    W4: 'WEEK4'
});

export const WeekFullEnum = Object.freeze({
    WEEK1: 'W1',
    WEEK2: 'W2',
    WEEK3: 'W3',
    WEEK4: 'W4'
});

export const WeekDayEnum = Object.freeze({
    MONDAY: 'MONDAY',
    TUESDAY: 'TUESDAY',
    WEDNESDAY: 'WEDNESDAY',
    THURSDAY: 'THURSDAY',
    FRIDAY: 'FRIDAY',
    SATURDAY: 'SATURDAY',
    SUNDAY: 'SUNDAY'
});

export const WeekDayShortEnum = Object.freeze({
    MO: 'MONDAY',
    TU: 'TUESDAY',
    WE: 'WEDNESDAY',
    TH: 'THURSDAY',
    FR: 'FRIDAY',
    SA: 'SATURDAY',
    SU: 'SUNDAY'
});

export const WeekDayFullEnum = Object.freeze({
    MONDAY: 'MO',
    TUESDAY: 'TU',
    WEDNESDAY: 'WE',
    THURSDAY: 'TH',
    FRIDAY: 'FR',
    SATURDAY: 'SA',
    SUNDAY: 'SU'
});
